import {Component, Input} from '@angular/core';
import {CustomDialogComponent} from "../../custom-dialog/custom-dialog.component";
import {EtablissementData} from "../../utils/data/etablissments-data";
import {MatDialog} from "@angular/material/dialog";
import {PersonsService} from "../../../services/persons.service";
import {FlagService} from "../../services/flag.service";
import {FlagType} from "../../utils/enums";
import { AddAgencyComponent } from '../../../core/agency/agency-management/add-agency/add-agency.component';
import { DetailsAgencyComponent } from '../../../core/agency/agency-management/details-agency/details-agency.component';
import { EstablishmentService } from '../../../services/establishment.service';


@Component({
  selector: 'app-agency-management-action',
  templateUrl: './agency-management-action.component.html',
  styleUrl: './agency-management-action.component.scss'
})
export class AgencyManagementActionComponent {
  @Input() data: any = undefined;
  @Input() column: any = undefined;


constructor(private dialog: MatDialog, private personService: PersonsService,private agencyService : EstablishmentService, private flag: FlagService) {

}

viewDialog = (row: any) => {
  console.log(this.data);
  this.dialog.open(DetailsAgencyComponent, {
    width: '666px',
    height: '100vh',
    position: { right: '0' },
    backdropClass: 'bg-transparent',
    data: this.data,
  });
};

editDialog(): void {
  const dialogRef = this.dialog.open(AddAgencyComponent, {
    data: this.data
  })
  dialogRef.afterClosed().subscribe(value => {
    if (value) {
      this.personService.toggleRefreshData()
    }
  })
}

  deletePerson() {
    const dialogRef  = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.monEtablissement.deleteAgenceDialog.title,
        description: EtablissementData.monEtablissement.deleteAgenceDialog.description,
        primaryLabel: EtablissementData.monEtablissement.deleteAgenceDialog.primaryButton,
        secondaryLabel: EtablissementData.monEtablissement.deleteAgenceDialog.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false
    })
    dialogRef.afterClosed().subscribe(value => {
      if (value)
         {
          this.agencyService.deleteAgency(this.data.id).subscribe({
          next: res =>
             {
                this.flag.displayFlag('La suppression est effectuée avec succès !', FlagType.success);
                this.personService.toggleRefreshData();                
              },
          error: err => {
          console.error('Delete error:', err);
          }
        });
      }
    })
  }
}


